import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const VisaInstruction = () => {
    const [visaInstructions, setVisaInstructions] = useState([]);
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const cacheExpiryTime = 30 * 60 * 1000; // 30 minutes in milliseconds

    useEffect(() => {
        // Check if visa instructions are available in localStorage
        const cachedData = JSON.parse(localStorage.getItem('visaInstructionsData'));

        if (cachedData) {
            const { data, timestamp } = cachedData;

            // Check if the cached data has expired (older than 30 minutes)
            const currentTime = Date.now();
            if (currentTime - timestamp < cacheExpiryTime) {
                // If not expired, use the cached data
                setVisaInstructions(data);
            } else {
                // If expired, clear the cache and fetch new data
                localStorage.removeItem('visaInstructionsData');
                fetchVisaInstructions();
            }
        } else {
            // If no cache, fetch data from the API
            fetchVisaInstructions();
        }
    }, []);

    const fetchVisaInstructions = async () => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_VISA_INSTRUCTION;
        try {
            const response = await axios.get(`${apiBaseUrl}${Url}`);
            const newData = response.data;

            // Save the fetched data along with the current timestamp in localStorage
            localStorage.setItem('visaInstructionsData', JSON.stringify({
                data: newData,
                timestamp: Date.now(),
            }));
            setVisaInstructions(newData);
        } catch (error) {
            console.error("Error fetching API", error);
        }
    };

    return (
        <section className="visa-area">
            <div className="container">
                <h1 className={'text-center py-5 fw-bold text-uppercase'}><i className={'fa fa-passport'}></i> Visa & Immigration <br />  Instructions</h1>
                <div className="row g-0">
                    {visaInstructions.map((visaInstruction, index) => {
                        return (
                            <div className="col-md-12 col-lg-6 rounded-3">
                                <div className="visa__items br-none rounded-3 m-2" style={{backgroundColor: `${visaInstruction?.color}`}}>
                                    <div className="visa__items-single d-flex align-items-center p-3">
                                        <h4 className="">
                                            <h4 className={'text-dark fw-bold'}>{visaInstruction?.title}</h4>
                                            <p className={'text-dark'}>{visaInstruction?.details}</p>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="country-wrap">
                    <div className="text-center my-2">
                        <Link className={'btn btn-primary my-2'} to={'/contact-us'}>KNOW MORE CLICK HERE <i className={'fa fa-plus'}></i></Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VisaInstruction;
